import React, { useEffect, useState } from "react";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import { useAxiosContext } from "../../../../context/AxiosContext";
import JobConfigration from "../../../../components/BuilderComponents/JobConfigration/JobConfigration";
import Input from "../../../../components/FormComponents/Input";
import Button from "../../../../components/FormComponents/Button";

const EditCalendarConfig = () => {
  const { applicationBlockData, currentBlockConfig, setCurrentBlockConfig } = useAppBlocksContext();
  const { data } = currentBlockConfig;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { axiosInstance, handleError } = useAxiosContext();
  const templateObject = {};
  const [allJobs, setAllJobs] = useState(null);

  const handleChangecalendar = (e) => {
    let { name, value } = e.target;
    if (name === "time_slot_duration") {
      value = value * 1;
    }
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data[name] = value;
    setCurrentBlockConfig(newcalendarConfig);
  };

  const fetchAllJobs = async () => {
    try {
      const { data } = await axiosInstance.get(`/jobs/filter/?places=records_view_row&elements=button`);
      setAllJobs(data);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    fetchAllJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleJobTriggerData = (data) => {
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data.add_event_config = data;
    setCurrentBlockConfig(newcalendarConfig);
    setIsModalOpen(false);
  };

  return (
    <div className="builder_form p_4">
      <Input label="Start Time" type="time" name="time_start" value={data.time_start} onChange={handleChangecalendar} />
      <Input label="End Time" type="time" name="time_end" value={data.time_end} onChange={handleChangecalendar} />
      <Input
        type="number"
        label="Time Slot Duration"
        min="0"
        name="time_slot_duration"
        value={data.time_slot_duration}
        onChange={handleChangecalendar}
      />
      {!applicationBlockData.config.data.add_event_config?.job_id && (
        <Button variant="secondary" onClick={() => setIsModalOpen(true)}>
          Assign job
        </Button>
      )}
      {applicationBlockData.config.data.add_event_config?.job_id && allJobs && (
        <>
          <label className="builder_label">Current Job</label>
          <div className="job_single_card rightpanel">
            <div className="overlay_cover"></div>
            <div className="job_action_btn">
              <ButtonActionIcon size="sm" type="edit" onClick={() => setIsModalOpen(true)} />
              <ButtonActionIcon size="sm" type="delete" onClick={() => handleJobTriggerData({})} />
            </div>
            <JobConfigration
              editJob={{
                job_id: applicationBlockData.config.data.add_event_config.job_id,
                params: applicationBlockData.config.data.add_event_config.params
              }}
              templateObject={templateObject}
              allJobs={allJobs}
              isReadOnly={true}
              smId={applicationBlockData.config.table_id}
              device={applicationBlockData.device}
            />
          </div>
        </>
      )}
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Add job">
        <JobConfigration
          editJob={
            applicationBlockData.config.data.add_event_config?.job_id
              ? {
                  job_id: applicationBlockData.config.data.add_event_config?.job_id,
                  params: applicationBlockData.config.data.add_event_config?.params
                }
              : null
          }
          templateObject={templateObject}
          allJobs={allJobs}
          onClick={(data) => handleJobTriggerData(data)}
          smId={applicationBlockData.config.table_id}
          device={applicationBlockData.device}
        />
      </BuilderModal>
    </div>
  );
};

export default EditCalendarConfig;
